module.exports = "img/photo35.a770fc.jpg";